import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AuthHandler } from 'app/auth/auth-handler.component';
import { AuthenticationService } from 'app/auth/auth.service';
import { Observable, Subject } from 'rxjs';
export interface User {
    password: string,
    new_password: string,
    last_login:	string,
    is_superuser:	boolean,
    username:	string,
    first_name: string,
    last_name:	string,
    is_staff:	boolean,
    is_active:	boolean,
    date_joined:	string,
    email:	string,
    ipaddress:	string,
    login_attempts:	number,
    reset_token:	number,
    last_reset_timestamp:	string,
    reset_retries:	number,
    user_permissions: [],
    groups: []
}

export interface MinUserData {
    username: string,
    email: string,
    user_id: number,
    is_staff: boolean,
    applications: string[],
    market_members: number,
    user_permissions: any
}

@Injectable({ providedIn: 'root' })
export class UserService {
    public authenticatedUser: User | null = null;
    public minUserData: MinUserData | null = null;
    public authenticatedUser$: Subject<User | null> = new Subject<User | null>();
    protected readonly http: HttpClient;    // custom para los servicios que se dan en contexto de home
    
    constructor(
        private authHandler: AuthHandler,
        private httpClient: HttpClient,
        private authenticationService: AuthenticationService,
    ) {
        this.http = new HttpClient(authHandler);
        this.authenticationService.isAuthenticatedSubject.subscribe((isAuthenticated) => {
           this.minUserData = this.authenticationService.loggedUser;
           this.getUser(this.minUserData?.user_id).subscribe((user) => {
               this.authenticatedUser = user;
               this.authenticatedUser$.next(user);
           });
        });
    }
    // getCurrentAuthUser() {
    //     return this.http.get('https://api.escuelajs.co/api/v1/auth/profile');
    // }


    changePassword(id: number, email: string, username: string, password: string, new_password: string, ) {
        return this.http.patch<any>(`${environment.CORE_URL}/access/user/${id}`, { password, new_password, email, username })
        .pipe(tap((response: any) => response));
    }

    getUser(id: number) {
        return this.http.get<User>(`${environment.CORE_URL}/access/user/${id}`)
        .pipe(tap((response: any) => response));
    }

    getUsersList() {
        return this.http.get<User[]>(`${environment.CORE_URL}/access/user`)
        .pipe(
            map((response: any) => this.isStaff() ? response.results : [response])
        );
    }

    isStaff() {
        return this.authenticatedUser?.is_staff;
    }

    retrieveApplicationAccess() {
        return this.authenticationService.loggedUser?.applications;
    }

   

}